import 'bootstrap'; // Bootstrap for UI components
import '@popperjs/core'; // Popper.js for positioning elements
import './../icon-font/iconly.css'; // Custom icon styles
import './../scss/theme.scss'; // Main theme styles

// Import  JS modules
import component from './../js/component.js';
import header from './../js/header.js';
import GeneralAjax from '../js/general-ajax.js';
import woocommerce from '../js/woocommerce.js';
import ArchiveAppend from '../js/archive-append.js';
import authentication from '../js/authentication.js';
import MediaPlayer from './../js/mediaplayer.js';
import StreamitInvoice from '../js/streamit-invoice.js';

// Document ready function
jQuery(document).ready(function ($) {
    // Initialize modules and assign to DashboardSideBarModule
    const DashboardSideBarModule = {
        'component': new component(),
        'header': new header(),
        'GeneralAjax': new GeneralAjax(),
        'woocommerce': new woocommerce(),
        'ArchiveAppend': new ArchiveAppend(),
        'authentication': new authentication(),
        'MediaPlayer': new MediaPlayer(),
        'StreamitInvoice': new StreamitInvoice()
    };

    // Attach the module to the global window object for external access
    window['DashboardSideBarModule'] = DashboardSideBarModule;

    // Initialize Select2 for dropdowns to enhance UX
    jQuery('select').select2({
        width: '100%'
    });
    jQuery('select[data-is-fullwidth="true"]').each(function () {
        const $select = jQuery(this);
        $select.select2({
            width: '',
            minimumResultsForSearch: -1,
            dropdownParent: $select.closest('.select-wrapper') // Important for width styling
        });

        // Add custom class for targeting dropdown
        $select.on('select2:open', function () {
            // Slight delay to let Select2 insert the dropdown
            setTimeout(() => {
                jQuery('.select2-dropdown')
                    .addClass('dropdown-fullwidth');
            }, 0);
        });
    });



    // Add a class to make Select2 dropdowns wide
    jQuery('.select2-container').addClass('wide');

    if (jQuery('#st_playlist_post_type').is('select')) {
        jQuery('#st_playlist_post_type').select2({
            width: '100%',
            dropdownParent: jQuery('#creatplaylistModal')
        });
    }


});
